function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

// http://jira.mmt.com/browse/GROW-3105
var WLCM_BCK = 'Welcome Back';
var loginToastInitState = {
  show: false,
  message: WLCM_BCK + "!"
};

var getMessage = function getMessage(fname) {
  if (fname && typeof fname === 'string') {
    // NOTE: Text capitalization happening from css
    return WLCM_BCK + " " + fname + "!"; // Welcome Back Rakesh!
  }

  return WLCM_BCK + "!"; // Welcome Back!
};

var loginToastReducer = function loginToastReducer(state, action) {
  switch (action.type) {
    case 'show':
      {
        var fname = action.fname,
            message = action.message;
        return {
          show: true,
          message: message || getMessage(fname)
        };
      }

    case 'hide':
    default:
      return _extends({}, loginToastInitState);
  }
};

export { loginToastInitState, loginToastReducer };
